import React, { Component } from 'react';
import { connect } from 'react-redux';
import JsonForm from 'react-jsonschema-form';
import { updateApplication, rewindApplication } from 'actions/applications';
import FormBase from './formBase';
import { formLoanProperties } from '../../fixtures/formLoanProperties';

const schema = {
  type: 'object',
  required: ['amount', 'termLength', 'termUnit', 'purpose', 'frequency', 'contactNumber', 'contactEmail', 'drawdownDate'],
  properties: {
    amount: {
      type: 'integer',
      title: 'Amount required',
      default: 50000,
      minimum: 10000,
      maximum: 500000
    },
    termLength: {
      type: 'integer',
      title: 'Term Duration',
      default: 1,
      minimum: 1
    },
    termUnit: {
      type: 'string',
      title: 'Term Unit',
      default: 'month',
      enum: ['week', 'month'],
      enumNames: ['Weekly', 'Monthly']
    },
    drawdownDate: {
      type: 'string',
      format: 'date',
      title: 'Drawdown Date',
    },
    purpose: {
      type: 'string',
      title: 'Where would you use the loan for?',
      enum: [
        'Hire Staff', 'Working Capital', 'Marketing Campaign', 'Expand Premises', 'GST Payment',
        'Payroll Tax Payment', 'Tax Payment', 'Purchase Equipment', 'Debt Consolidation',
        'Payment of Existing Arrears', 'Other'
      ]
    },
    frequency: {
      type: 'string',
      title: 'How often would you like to make repayment?',
      default: 'month',
      enum: ['week', 'month'],
      enumNames: ['Weekly', 'Monthly']
    },
    contactNumber: {
      type: 'string',
      title: 'Your best contact number',
    },
    contactEmail: {
      type: 'string',
      title: 'Email address',
    },
  }
};

const validate = (formData, errors) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!emailRegex.test(formData.contactEmail.toLowerCase())) {
    errors.contactEmail.addError("Please enter a valid email address");
  }
  return errors;
}

const uiSchema = {
  purpose: {
    'ui:placeholder': 'Please choose'
  },
  drawdownDate: {
    "ui:widget": "alt-date",
    "ui:options": {
      yearsRange: [2018, 2020],
    },
  }
};

const mergedSchema = Object.assign({}, schema, formLoanProperties());

class FormLoanDetails extends FormBase {
  static defaultProps = { schema: mergedSchema, uiSchema, validate }
}

const connected = connect(() => {})(FormLoanDetails);
export default connected;



// WEBPACK FOOTER //
// ./src/containers/Application/formLoanDetails.js